import { useLcaData } from '@/stores/pathwayTemplateAnalysisStore';
import { smartRound } from '@/utils/miscUtils';
import { getEmissionsUnit, normalize } from '@/utils/pathwayTemplateUtils';
import LoadingSkeleton from '../core/LoadingSkeleton';
import AnalysisContainer from '../core/AnalysisContainer';
import AnalysisBox from '../core/AnalysisBox';

const EmissionsBreakdownTable = () => {
  const { data, loading, error } = useLcaData();

  if (loading && !data) return <LoadingSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  const emissions = normalize(data?.emissions, 'label', 'quantity.scalar') || [];
  const total = emissions.reduce((sum, item) => sum + item.value, 0);
  const unit = getEmissionsUnit(data);

  return (
    <AnalysisContainer title={`Emissions Breakdown (${unit})`}>
      <AnalysisBox>
        {emissions.map((item, index) => (
          <div key={index} className="flex justify-between items-center">
            <span className="text-sm text-gray-600">{item.label}</span>
            <span className="text-sm font-semibold text-gray-900">{smartRound(item.value, 2, 3)}</span>
          </div>
        ))}
        <div className="flex justify-between items-center pt-3 border-t border-gray-200/30">
          <span className="text-sm font-semibold text-gray-900">Total</span>
          <span className="text-sm font-bold text-gray-900">{smartRound(total, 2, 3)}</span>
        </div>
      </AnalysisBox>
    </AnalysisContainer>
  );
};

export default EmissionsBreakdownTable;
